import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';

import useAlert from 'hooks/useAlert';

import axios from 'services/axios';
import { OTO_LINK } from 'services/consts';

import { setLoading } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';

import { tapPaymentToken } from './TapIframe';

let popup;
const ChargeTapPayment = ({ beforeOnPayment, onComplete, savedCard, buttonProps = {}, apiURL, body = {} }) => {
	const formMethods = useFormContext();
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state?.layout);
	const { showError } = useAlert();
	const { handleSubmit, watch } = formMethods;
	const [paymentResultChecking, setPaymentResultChecking] = useState(false);

	const checkPayment = async (id) =>
		axios
			.post(OTO_LINK.CHECK_CHARGE, {
				ID: id,
				key: watch('key'),
				GUID: watch('GUID'),
				otoLinkSessionId: watch('otoLinkSessionId')
			})
			.then((res) => {
				const { data, status } = res;
				if (status === 200 && data) {
					if (data.status === 'failed') {
						showError({
							header: 'error',
							...(data?.description && { message: data?.description })
						});
						AppLogger.error(data);
						dispatch(setLoading(false));
					} else if (data.status === 'paid') {
						dispatch(setLoading(false));
						onComplete(data);
					} else {
						setTimeout(() => {
							checkPayment(id);
						}, 3 * 1000);
					}
				} else {
					showError();
					AppLogger.error(res);
					dispatch(setLoading(false));
				}
			})
			.catch((error) => {
				showError();
				AppLogger.error(error);
				dispatch(setLoading(false));
			});

	useEffect(() => {
		const handleMessage = (message) => {
			if (message.data.event !== 'checkPaymentResult') return;

			setPaymentResultChecking(true);
			popup?.close();

			setTimeout(() => {
				checkPayment(message.data?.paymentID);
			}, 5 * 1000); // wait for 5 second to make sure the webhook is triggered
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	useEffect(() => {
		if (!loading || paymentResultChecking) return;
		const interval = setInterval(() => {
			if (popup?.closed) {
				dispatch(setLoading(false));
			}
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, [loading, paymentResultChecking]);

	const sendPaymentRequest = async () => {
		await axios
			.post(apiURL, {
				token: tapPaymentToken,
				...body
			})
			.then((res) => {
				const { data, status } = res;
				if (status === 200 && data) {
					const { transactionUrl } = data;
					if (transactionUrl) {
						popup.location.href = transactionUrl;
					} else {
						popup.close();
						onComplete(data);
						dispatch(setLoading(false));
					}
				} else {
					popup.close();
					showError();
					AppLogger.error(res);
					dispatch(setLoading(false));
				}
			})
			.catch((error) => {
				popup.close();
				dispatch(setLoading(false));
				showError();
				AppLogger.error(error);
			});
	};

	const completeCreditPayment = async () => {
		dispatch(setLoading(true));
		await beforeOnPayment?.();
		popup = window.open('/payment-redirect-en.html', '_blank');

		if (savedCard) {
			await sendPaymentRequest();
		} else {
			window.CardSDK.tokenize();
		}
	};

	const handleTokenCreate = () => {
		sendPaymentRequest();
	};

	const handleTokenError = () => {
		popup.close();
		dispatch(setLoading(false));
		showError();
	};

	useEffect(() => {
		window.addEventListener('tapPaymentTokenCreated', handleTokenCreate);
		window.addEventListener('tapPaymentTokenError', handleTokenError);

		return () => {
			window.removeEventListener('tapPaymentTokenCreated', handleTokenCreate);
			window.removeEventListener('tapPaymentTokenError', handleTokenError);
		};
	}, []);

	return (
		<Button
			label={buttonProps?.label || 'completePayment'}
			loading={loading}
			onClick={handleSubmit(completeCreditPayment, (errors) => {
				AppLogger.log('Payment Error', errors);
			})}
			className="payment-form-button"
			{...buttonProps}
		/>
	);
};

export default ChargeTapPayment;
